export default {
  uploading: 'Enviando',
  cancel: 'Cancelar',
  modelTrainingProgress: 'Progresso do Treinamento do Modelo',
  stage: 'Etapa',
  deliverables: 'Entregáveis',
  status: 'Status',
  actions: 'Ações',
  completed: 'Concluído',
  pending: 'Pendente',
  approveStage: 'Aprovar Etapa',
  undoApproval: 'Desfazer aprovação',
  upload: 'Enviar',
  deleteFileConfirm: 'Tem certeza de que deseja excluir o arquivo?',
  unsupportedFiles: 'Estes arquivos foram ignorados porque só é possível enviar relatórios HTML e planilhas Excel (.xlsx, .xls): {files}',
  errorUploadingFile: 'Erro ao enviar o arquivo.',
  viewReport: 'Ver relatório',
  downloadDeliverable: 'Baixar {name}',
  deliverableKinds: {
    report: 'Relatório',
    modelReport: 'Excel Model Report',
    inputsReport: 'Inputs Report'
  },
  assignTitle: 'Enviar para {stage}',
  assignHint: 'Atribua cada planilha ao seu tipo antes de enviá-la. Uma única planilha, ou um par em que só uma tem "input" no nome, já vem atribuída.',
  assignPlaceholder: 'Escolha um tipo',
  tooManySpreadsheets: 'É possível enviar no máximo {max} planilhas de uma vez (um Excel Model Report e um Inputs Report). Nada foi enviado.',
  assignRepeated: 'Há mais de um arquivo definido como {kinds}: eles serão enviados como versões consecutivas.',
  uploadingCount: '({current} de {total})',
  sendFeedback: 'Enviar feedback',
  feedbackUnavailable: 'Disponível quando {stage} tiver um relatório ou uma planilha',
  feedbackStaff: 'Equipe da NG',
  feedbackFirst: 'Primeiro feedback: {date}',
  feedbackLast: 'Último: {date}'
}
